import { render } from "./top_stats_bar.vue?vue&type=template&id=2852df3c&scoped=true"
import script from "./top_stats_bar.vue?vue&type=script&lang=js"
export * from "./top_stats_bar.vue?vue&type=script&lang=js"

import "./top_stats_bar.vue?vue&type=style&index=0&id=2852df3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2852df3c"]])

export default __exports__